import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { MediaImage_Fragment } from "./mediaimage";
// import { Video_Fragment } from "./video";

export const MetafieldReferenceConnectionMasked_Fragment =
  graphqlShopifyStorefront(
    `
  fragment MetafieldReferenceConnectionMasked on MetafieldReferenceConnection {
    edges {
      node {
        __typename
        ...MediaImage
        ...Video
      }
    }
  }
`,
    // [MediaImage_Fragment, Video_Fragment],
  );
